<template>
  <div id="documentation">
    <Navigation/>
    <div class="container-fixed">
      <div class="doc-services-box" style="display: flex; flex-direction: row;">
        <div class="doc-services">
          <div>
            <div class="doc-services-title animate__animated animate__fadeInLeft">
              3D 시뮬레이터 서비스
              <div class="doc-services-title-desc">
                현실감 넘치는 그래픽과 직관적인 사용자 경험을 제공하는 3D 시뮬레이터 서비스를 만나보세요.
              </div>
            </div>
            <ul class="service-links animate__animated animate__fadeInLeft animate__delay-1s">
              <li v-for="service in services" v-bind:key="service.id" :class="service.id == selected_service_id ? ' selected':''">
                <a href="javascript:void(0)" @click="previewService(service.id)">{{service.title}}</a>
              </li>
            </ul>
          </div>
        </div>
        <div class="doc-services-content">
          <div class="doc-3d-content-1" :style="selected_service_id == 1 ? '':'display:none'">
            <img src="/assets/images/3d/1/Img_1.png" class="animate__animated animate__fadeInRight" alt="">
            <div class="animate__animated animate__fadeInRight animate__delay-1s">
              <div class="doc-3d-content-1-title">현실감 있는 그래픽</div>
              <div class="doc-3d-content-1-body">최첨단 3D 시뮬레이터는 사실적인 그래픽과 직관적인 인터페이스를 제공하여 제조, 교육, 의료, 군사 등 다양한 산업 분야에 적용됩니다..</div>
            </div>
            <div class="animate__animated animate__fadeInRight animate__delay-2s">
              <div class="doc-3d-content-1-title">빠른 학습 지원</div>
              <div class="doc-3d-content-1-body">고도 정밀 모델링과 애니메이션을 통해 복잡한 시스템 작동을 시각적으로 확인할 수 있어 빠르고 효과적인 학습이 가능합니다. 또한 학습과 훈련의 효율성을 높이며 안전성과 비용 절감을 지원합니다.</div>
            </div>
            <img src="/assets/images/3d/1/Img_2.png" class="animate__animated animate__fadeInRight animate__delay-3s" alt="">
          </div>
          <div class="doc-3d-content-2" :style="selected_service_id == 2 ? '':'display:none'">
            <div class="doc-3d-content-2-list">
              <div class="doc-3d-content-2-row animate__animated animate__fadeInRight">
                <img src="/assets/images/3d/2/1.png" class="doc-3d-content-2-icon" alt="">
                <div class="doc-3d-content-2-details">
                  <div class="doc-3d-content-2-title">정밀성</div>
                  <div class="doc-3d-content-2-desc">전문 모델러가 제작한 고품질 3D 모델로 서비스의 가치를 극대화 합니다</div>
                </div>
              </div>
              <div class="doc-3d-content-2-row animate__animated animate__fadeInRight animate__delay-1s">
                <img src="/assets/images/3d/2/2.png" class="doc-3d-content-2-icon" alt="">
                <div class="doc-3d-content-2-details">
                  <div class="doc-3d-content-2-title">네트워크</div>
                  <div class="doc-3d-content-2-desc">언어별, 분야별 전문 인적자원으로 최고의 번역 품질을 유지합니다.</div>
                </div>
              </div>
              <div class="doc-3d-content-2-row animate__animated animate__fadeInRight animate__delay-2s">
                <img src="/assets/images/3d/2/3.png" class="doc-3d-content-2-icon" alt="">
                <div class="doc-3d-content-2-details">
                  <div class="doc-3d-content-2-title">기술</div>
                  <div class="doc-3d-content-2-desc">다양한 CAT 도구 활용 및 클라우드 번역 환경을 통해 최고의 번역 환경을 유지합니다.</div>
                </div>
              </div>
              <div class="doc-3d-content-2-row animate__animated animate__fadeInRight animate__delay-3s">
                <img src="/assets/images/3d/2/4.png" class="doc-3d-content-2-icon" alt="">
                <div class="doc-3d-content-2-details">
                  <div class="doc-3d-content-2-title">품질</div>
                  <div class="doc-3d-content-2-desc">QA 도구를 통한 언어 품질 검사와 자체 체크 리스트를 통해 오류를 최소화 합니다.</div>
                </div>
              </div>
            </div>
            <div class="doc-3d-content-2-img animate__animated animate__fadeInRight animate__delay-4s" style="background-image: url(/assets/images/3d/2/Image.png);"></div>
          </div>
          <div class="doc-3d-content-3" :style="selected_service_id == 3 ? '':'display:none'">
            <img src="/assets/images/3d/3/img-1.png" class="animate__animated animate__fadeInRight" alt="">
            <div class="animate__animated animate__fadeInRight animate__delay-1s">
              <div class="doc-3d-content-3-title">제조</div>
              <div class="doc-3d-content-3-body">제품 설계, 생산 공정 최적화를 지원하여 제조 과정을 혁신적으로 개선합니다</div>
            </div>
            <div class="animate__animated animate__fadeInRight animate__delay-1s">
              <div class="doc-3d-content-3-title">교육 및 의료</div>
              <div class="doc-3d-content-3-body">3D 시뮬레이터를 통해 실습 중심의 학습 환경을 제공하여 학습의 효율을 높입니다.</div>
            </div>
            <img src="/assets/images/3d/3/img-2.png" class="animate__animated animate__fadeInRight animate__delay-2s" alt="">
            <img src="/assets/images/3d/3/img-3.png" class="animate__animated animate__fadeInRight animate__delay-3s" alt="">
            <div class="animate__animated animate__fadeInRight animate__delay-4s">
              <div class="doc-3d-content-3-title">군사</div>
              <div class="doc-3d-content-3-body">전술 훈련, 장비 작동 교육을 위한 현실감 넘치는 환경을 제공합니다</div>
            </div>
          </div>
          <div id="doc-3d-content-4" class="doc-3d-content-4" :style="selected_service_id == 4 ? '':'display:none'">
            <div class="doc-3d-content-4-ctr animate__animated animate__fadeInUp">
              <ul>
                <li :class="selected_service_id4 == 1 ? 'doc-3d-content-4-ctr-active':''" @click="previewService4(1)">01</li>
                <li :class="selected_service_id4 == 2 ? 'doc-3d-content-4-ctr-active':''" @click="previewService4(2)">02</li>
                <li :class="selected_service_id4 == 3 ? 'doc-3d-content-4-ctr-active':''" @click="previewService4(3)">03</li>
                <li :class="selected_service_id4 == 4 ? 'doc-3d-content-4-ctr-active':''" @click="previewService4(4)">04</li>
                <li :class="selected_service_id4 == 5 ? 'doc-3d-content-4-ctr-active':''" @click="previewService4(5)">05</li>
              </ul>
            </div>
            <div class="doc-3d-content-4-content animate__animated animate__fadeInRight animate__delay-1s">
              <div v-if="selected_service_id4 == 1" class="doc-3d-content-4-details animate__animated animate__fadeIn">
                <img src="/assets/images/3d/4/animation-1.gif" alt="">
                <div class="doc-3d-content-4-title">시나리오 제작</div>
                <div class="doc-3d-content-4-desc">시뮬레이터의 목적과 사용자의 요구사항 정의</div>
                <div class="doc-3d-content-4-overlay">
                  <img src="/assets/images/3d/4/animation-overlay.jpg" alt="">
                </div>
              </div>
              <div v-if="selected_service_id4 == 2" class="doc-3d-content-4-details animate__animated animate__fadeIn">
                <img src="/assets/images/3d/4/animation-2.gif" alt="">
                <div class="doc-3d-content-4-title">3D 모델링</div>
                <div class="doc-3d-content-4-desc">시뮬레이터에 필요한 정밀한 3D 모델 디자인 및 생성</div>
                <div class="doc-3d-content-4-overlay">
                  <img src="/assets/images/3d/4/animation-overlay.jpg" alt="">
                </div>
              </div>
              <div v-if="selected_service_id4 == 3" class="doc-3d-content-4-details animate__animated animate__fadeIn">
                <img src="/assets/images/3d/4/animation-3.gif" alt="">
                <div class="doc-3d-content-4-title">3D 애니메이션 제작</div>
                <div class="doc-3d-content-4-desc">모델에 애니메이션을 추가하여 시뮬레이터 작동을 시각화</div>
                <div class="doc-3d-content-4-overlay">
                  <img src="/assets/images/3d/4/animation-overlay.jpg" alt="">
                </div>
              </div>
              <div v-if="selected_service_id4 == 4" class="doc-3d-content-4-details animate__animated animate__fadeIn">
                <img src="/assets/images/3d/4/animation-4.gif" alt="">
                <div class="doc-3d-content-4-title">Unity 개발</div>
                <div class="doc-3d-content-4-desc">Unity 엔진을 사용해 인터랙티브한 시뮬레이터 프로그래밍</div>
                <div class="doc-3d-content-4-overlay">
                  <img src="/assets/images/3d/4/animation-overlay.jpg" alt="">
                </div>
              </div>
              <div v-if="selected_service_id4 == 5" class="doc-3d-content-4-details animate__animated animate__fadeIn">
                <img src="/assets/images/3d/4/animation-5.gif" alt="">
                <div class="doc-3d-content-4-title">UI 구현 및 최종 컴파일</div>
                <div class="doc-3d-content-4-desc">사용자 친화적인 인터페이스 설계 및 시뮬레이터 완성</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <BgTextree/>
  </div>
</template>

<script>
import store from '@/store'

export default {
  components: {
    Navigation: () => import('@/components/nav.vue'),
    BgTextree: () => import('@/components/bg-textree.vue')
  },
  data: () => ({
    services: [
      {
        id: 1,
        title: '서비스 소개',
      },
      {
        id: 2,
        title: '서비스 도입 장점'
      },
      {
        id: 3,
        title: '서비스 제공 분야'
      },
      {
        id: 4,
        title: '제작 프로세스'
      }
    ],
    selected_service_id: 1,
    selected_service_id4: 1
  }),
  mounted() {
    store.commit('SET_NAV_PAGE', '3dsimulator')
    store.commit('SET_NAV_THEME', 'dark')
    this.previewService(1);
  },
  methods: {
    previewService: function (id) {
      this.selected_service_id4 = 1;
      this.selected_service_id = id;
    },
    previewService4: function (ctr) {
      this.selected_service_id4 = ctr;
    },
    onScroll4: function (event) {
      if (event.deltaY < 0 && this.selected_service_id4 > 1) {
        this.selected_service_id4--
      }
      if (event.deltaY > 0 && this.selected_service_id4 < 5) {
        this.selected_service_id4++
      }
    }
  },
  watch: {
    selected_service_id: function (selected_id) {
      if (selected_id == 4) {
        console.log('scrool')
        var self = this;
        if (this.pageWidth > 768) {
          window.addEventListener('wheel', function(event) {
            self.onScroll4(event)
          })
        } else {
          document.getElementById('doc-3d-content-4').addEventListener('wheel', function(event) {
            self.onScroll4(event)
          })
        }
      }
    }
  }
}
</script>
<style scoped>
.doc-services-content {
  position: relative;
}

.doc-3d-content-1 {
  display: grid;
  grid-template-columns: 50% 50%;
  gap: 50px;
}

.doc-3d-content-1>img {
  max-width: 100%;
}

.doc-3d-content-1>div {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.doc-3d-content-1-title {
  font-family: "Roboto";
  color: #000000;
  font-size: 30px;
  line-height: 70px;
  margin-bottom: 1rem;
  font-weight: 600;
}

.doc-3d-content-1-body {
  font-family: "Roboto";
  color: #000000;
  font-size: 16px;
  line-height: 32px;
  font-weight: 400;
}

.doc-3d-content-2 {
  position: absolute;
  display: flex;
  flex-direction: row;
  width: 150%;
}

.doc-3d-content-2-list {
  width: 45%;
}

.doc-3d-content-2-img {
  width: 105%;
  min-height: 100%;
  background-size: contain;
  background-repeat: no-repeat;
  margin-left: 5rem;
}

.doc-3d-content-2-row {
  display: flex;
  flex-direction: row;
  margin-bottom: 3.5rem;
}

.doc-3d-content-2-row:first-child {
  margin-top: 2rem;
}

.doc-3d-content-2-row:last-child {
  margin-bottom: 8rem;
  padding-bottom: 5rem;
}

.doc-3d-content-2-icon {
  width: 60px;
  height: 60px;
  margin-right: 1rem;
}

.doc-3d-content-2-title {
  font-family: "Montserrat";
  color: #008ED6;
  font-size: 22px;
  line-height: 22px;
  margin-bottom: 1rem;
  font-weight: 700;
}

.doc-3d-content-2-desc {
  font-family: "Roboto";
  color: #000000;
  font-size: 16px;
  line-height: 30px;
  font-weight: 400;
}

.doc-3d-content-3 {
  display: grid;
  width: 90%;
  grid-template-columns: 50% 50%;
  gap: 35px;
}

.doc-3d-content-3>img {
  max-width: 100%;
}

.doc-3d-content-3>div {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.doc-3d-content-3-title {
  font-family: "Roboto";
  color: #000000;
  font-size: 30px;
  line-height: 45px;
  margin-bottom: 1rem;
  font-weight: 600;
}

.doc-3d-content-3-body {
  font-family: "Roboto";
  color: #000000;
  font-size: 16px;
  line-height: 32px;
  font-weight: 400;
}

.doc-3d-content-4 {
  display: flex;
  flex-direction: row;
  width: 85%;
  position: relative;
}

.doc-3d-content-4-ctr ul {
  list-style: none;
  margin-top: 0;
  margin-right: 5rem;
  margin-bottom: 0;
  cursor: pointer;
  border-right: 1px solid #d9d9d9;
}

.doc-3d-content-4-ctr li {
  padding: 3rem 2rem;
  margin-bottom: 2rem;
  margin-right: -2px;
  font-family: "Montserrat";
  color: #bfbfbf;
  font-size: 22px;
  line-height: 44px;
  margin-bottom: 1rem;
  font-weight: 700;
}

.doc-3d-content-4-ctr li.doc-3d-content-4-ctr-active {
  border-right: 4.71px solid #008ED6;
  color: #008ED6;
}

.doc-3d-content-4-ctr li:last-child {
  margin-bottom: 0;
}

.doc-3d-content-4-content {
  position: absolute;
  max-height: 100%;
  overflow-y: hidden;
  width: calc(100% - (2rem + 2rem + 5rem));
  left: calc(40px + 2rem + 2rem + 5rem + 5px);
}

.doc-3d-content-4-overlay {
  margin-top: 2rem;
  position: relative;
}

.doc-3d-content-4-overlay::after {
  content: '';
  top: 0;
  left: 0;
  position: absolute;
  width: 100%;
  height: 100%;
  background-image: linear-gradient(rgba(255, 255, 255, 84%), rgba(255, 255, 255, 100%), rgba(255, 255, 255, 100%));
}

.doc-3d-content-4 img {
  max-width: 100%;
  margin-bottom: 1.5rem;
}

.doc-3d-content-4-title {
  font-family: "Roboto";
  color: #000000;
  font-size: 30px;
  line-height: 60px;
  margin-left: 1.5rem;
  font-weight: 600;
}

.doc-3d-content-4-desc {
  font-family: "Roboto";
  color: #000000;
  font-size: 16px;
  line-height: 32px;
  margin-left: 1.5rem;
  font-weight: 400;
}
.doc-services-content {
  transform: translateX(-50px) translateY(-50px);
  width: 80%;
  display: flex;
  align-items: center;
}
.doc-services-box {
  max-width: 1600px;
  transform: translateX(100px);
  margin-top: 150px;
  margin-left: auto;
  margin-right: auto;
  height: calc(100% - 100px);
  z-index: 144;
  position: relative;
}
.doc-services {
  margin-top: -5em;
  width: 75%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.doc-services > div {
  width: calc(100% - 100px - 48px);
  padding-left: 100px;
  padding-right: 48px;
}

.doc-services-title {
  color: #008ED6;
  padding: 0 12px;
  font-family: "Montserrat";
  font-size: 22px;
  line-height: 70px;
  font-weight: bold;
  margin-bottom: 3rem;
}
.doc-services-title-desc {
  color: #000000;
  font-family: "Roboto";
  font-size: 24px;
  line-height: 50px;
  font-weight: 500;
  width: 85%;
}

ul.service-links {
  list-style-type: none;
  padding: 0;
}
ul.service-links li a {
  color: #CFCFCF;
  padding: 6px 12px;
  font-family: "Roboto";
  font-size: 45px;
  line-height: 70px;
  text-decoration: none;
  position: relative;
}
ul.service-links li.selected a {
  color: #2E2E2E;
}
ul.service-links li.selected a::before {
  position: absolute;
  border-top: 1px solid #707070;
  content: " ";
  width: 75px;
  top: 50%;
  left: -100px;
}

.service-preview {
  position: absolute;
  right: 0;
  bottom: 0;
  width: calc(100% - 45%);
  height: calc(100% - 100px);
  background-size: cover;
  background-position: center;
  z-index: 1;
}
.service-body {
  position: absolute;
  left: 0;
  bottom: 0;
  width: calc(75% - 48px);
  background: #008ED6;
  color: white;
  padding: 24px;
}

.service-title {
  font-family: "Nanum Gothic";
  font-size: 40px;
  font-weight: bold;
  line-height: 30px;
  padding: 24px;
}
.service-desc {
  font-family: "Nanum Gothic";
  font-size: 24px;
  font-weight: normal;
  line-height: 45px;
  padding: 0 24px;
  width: calc(75% - 12px);
}

.service-link a {
  display: inline-block;
  color: white;
  background: #F1B500;
  padding: 12px 24px;
  border-radius: 31px;
  text-decoration: none;
  z-index: 1024;
  margin: 12px 0 0;
}

@media(max-width: 1440px) {
  .doc-services-box {
    margin-top: 66px;
    height: calc(100% - 66px);
    transform: translate(0);
  }
  .doc-services {
    margin-top: 0;
    width: 65%;
  }
  .doc-services-title-desc {
    line-height: 150%;
  }
  ul.service-links li a {
    font-size: 40px;
  }
  .doc-3d-content-1 {
    gap: 30px;
  }
}

@media(max-width: 1024px) {
  .doc-services-box {
    flex-direction: column !important;
  }
  .doc-services-title {
    margin-bottom: 24px;
    width: 100%;
  }
  .doc-services-title-desc {
    width: 100%;
  }
  .doc-services {
    width: 100%;
    height: auto;
  }
  .doc-services-content {
    width: 100%;
  }
  ul.service-links {
    margin: 0;
  }
  ul.service-links li a {
    font-size: 24px;
    line-height: 175%;
  }
  ul.service-links li.selected a::before {
    width: 50px;
    left: -60px;
  }
  .doc-services-content {
    width: 100%;
    padding: 64px;
    transform: translate(0);
  }
  .doc-services-content>div {
    width: calc(100% - 64px - 64px);
  }
  .doc-3d-content-1 {
    display: flex;
    flex-direction: column;
  }
  .doc-3d-content-1>*:nth-child(3) {
    order: 3;
  }
  .doc-3d-content-1>*:nth-child(4) {
    order: 2;
  }
  .doc-3d-content-2 {
    position: relative;
  }
  .doc-3d-content-2-list {
    width: 50%;
  }
  .doc-3d-content-2-img {
    margin-left: 2rem;
    width: 50%;
    background-size: cover;
    background-position: center;
  }

  .doc-3d-content-3 {
    display: flex;
    flex-direction: column;
  }
  .doc-3d-content-3 > *:nth-child(3) {
    order: 4;
  }
  .doc-3d-content-3>*:nth-child(4) {
    order: 3;
  }

  .doc-3d-content-4-ctr ul {
    margin-left: 0;
    margin-right: 24px;
    padding-left: 0;
  }
  .doc-3d-content-4-content {
    left: 120px;
    width: calc(100% - 120px);
  }
  .doc-3d-content-4 img {
    max-width: auto;
    width: 100%;
  }
}

@media(max-width: 640px) {
  .doc-services-content {
    width: 100%;
    margin: 24px auto;
    padding: 24px;
    transform: translate(0);
  }
  .doc-services-content>div {
    width: calc(100% - 24px - 24px);
  }
  .doc-service-content-4-icon {
    width: auto;
  }
  .doc-3d-content-2-list {
    width: 60%;
  }
  .doc-3d-content-2-img {
    width: 40%;
  }
  .doc-3d-content-4-ctr li {
    padding: 1.5rem 1rem;
  }
  .doc-3d-content-4-content {
    left: 90px;
    width: calc(100% - 90px);
  }
}
</style>

<style>
#plusfriend-chat-button {
  bottom: 76px;
}
#plusfriend-chat-button a {
  right: -128px;
}

@media(max-width: 1440px) {
  #plusfriend-chat-button a {
    right: 12px;
  }
}

@media(max-width: 1024px) {
  #plusfriend-chat-button {
    bottom: 200px;
  }
}

@media(max-width: 576px) {
  #plusfriend-chat-button {
    bottom: 24px;
  }
}
</style>
